import Vue from 'vue';
import VueResource from 'vue-resource';
import router from '@/router';

Vue.use(VueResource);

export const fncPopulateUsers = ({commit, dispatch, state, rootState}, payload)  => {
  var isParent = 0;
  if( payload.parent ) { isParent = payload.parent; }
  if( rootState.objAuthorize.length > 0 ) {
    var objAuth = JSON.parse(rootState.objAuthorize);
  } else {
    var objAuth = [];
  }
	if (payload.context == 2) {
		var user_details = {
			a: 'expand_company_user_tree',
			manufacturer: objAuth.manufacturer,
			parent: isParent,
            node_type: 0,
			user: objAuth.id,
			search: '',
			user_context: payload.context
		};
		Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'users_tree_da.php', { params: user_details }, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				console.log(error);
			}).then(data => {

				var user_details = {
					a: 'expand_user_tree',
					manu: objAuth.manufacturer,
					user: objAuth.id,
					ctx: process.env.CTX,
					user_context: payload.context,
					myorder: true
				};
				Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'users_tree_data_handler.php', { params: user_details }, rootState.headerDetails)
					.then(response => {
						return response.json();
					}, error => {
						console.log(error);
					}).then(d => {

						commit({
							type: 'setUsers',
							users: data,
							branchUsers: d,
							context: payload.context
						});
						commit('fncSetCustomersLoaded', true);
					});
			});
	} else {
    if( router.history.current.query.manufacturer != null ) {

      var user_details = {
        a: 'expand_user_tree',
        manu: router.history.current.query.manufacturer,
        user: objAuth.id,
        parent: isParent,
        ctx: process.env.CTX,
        user_context: payload.context,
        page: payload.page,
        notification: 0
      };

      if( payload.hide_details ) {
        user_details.hide_details = true;
      }

    } else {

      var notification = 0;
      if( payload.notification != null ) {
        notification = payload.notification;
      }

      var user_details = {
        a: 'expand_user_tree',
        manu: objAuth.manufacturer,
        user: objAuth.id,
        parent: isParent,
        ctx: process.env.CTX,
        user_context: payload.context,
        page: payload.page,
        search: payload.search,
        notification: notification

      };

      if( payload.hide_details ) {
        user_details.hide_details = true;
      }
    }

		Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'users_tree_data_handler.php', { params: user_details }, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				console.log(error);
			}).then(data => {
        let users
        if (data.hasOwnProperty('users')) {
          users = data.users;
        } else {
           users = data;
        }

				commit({
					type: 'setUsers',
					users: users,
					context: payload.context,
          hide_details: payload.hide_details
				});
				if (payload.context == '1' ) {
					commit('fncSetRepsLoaded', true);
				} else if (payload.context == '3' ) {
					commit('fncSetSpecifierLoaded', true);
				} else if (payload.context == '4' ) {
					commit('fncSetPublicLoaded', true);
          commit('fncSetPublicUserTotalPages', data.total_pages);
				} else if (payload.context == '6' ) {
					commit('fncSetVendorLoaded', true);
				}
			});
	}
};

export const fncEditSettings = ({commit, dispatch, state, rootState}, payload) => {
    var objAuth = JSON.parse(rootState.objAuthorize);
    var editDetails = {
        manufacturer: objAuth.manufacturer,
        manu_user_alias: payload.manufacturerAlias,
        manu_user_clr: payload.manufacturerColor,
        customer_user_alias: payload.customerAlias,
        customer_user_clr: payload.customerColor,
        specifier_user_alias: payload.specificAlias,
        specifier_user_clr: payload.specificColor,
        public_user_alias: payload.publicAlias,
        public_user_clr: payload.publicColor,
        quote_expiry: objAuth.quote_expiry
    };
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=save_user_settings', {params: editDetails}, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            var snackDetails = {color: 'error', message: 'An error occured while trying to update the user settings', display: true};
            commit('setSnack', snackDetails);
        }).then(data => {
			data = JSON.parse(data);
        	if( data.hasOwnProperty('msg') && data.msg === 'success' ) {
                var snackDetails = {color: 'success', message: 'The user settings were updated successfully', display: true};
                commit('setSnack', snackDetails);
				commit('hideModal');
				commit({
					type: 'setObjUserSettings',
					manu_user_alias: payload.manufacturerAlias,
					manu_user_clr: payload.manufacturerColor,
					customer_user_alias: payload.customerAlias,
					customer_user_clr: payload.customerColor,
					specifier_user_alias: payload.specificAlias,
					specifier_user_clr: payload.specificColor,
					public_user_alias: payload.publicAlias,
					public_user_clr: payload.publicColor
				});
			} else {
                var snackDetails = {color: 'error', message: 'An error occured while trying to update the user settings', display: true};
                commit('setSnack', snackDetails);
			}
    });
}

export const fncImportUsers = ({ commit, dispatch, state, rootState }, payload) => {
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            console.log(error);
        }).then(data => {
        var objAuthorize = JSON.parse( rootState.objAuthorize );
        var pricelistDetails = {token: data.token, manufacturer_id: objAuthorize.manufacturer, default: 1};
        Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: pricelistDetails }, rootState.headerDetails)
            .then(response => {
                return response.json();
            }, error => {
                console.log(error);
            }).then(data => {
				var pricelistId = data[0].pl_id;
				var params = { default_pl: pricelistId, rows: payload, manufacturer_id: objAuthorize.manufacturer, current_user_id: objAuthorize.id };
				Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=import_users', {params: params}, rootState.headerDetails)
					.then(response => {
						return response.json();
					}, error => {
						var snackDetails = {color: 'error', message: 'An error occured while trying to import the users', display: true};
						commit('setSnack', snackDetails);
					}).then(data => {
                    	if( !data.hasOwnProperty('error') ) {
                            var snackDetails = {color: 'success', message: 'The users were imported successfully', display: true};
                            commit('setSnack', snackDetails);
                            commit('hideModal');
							dispatch({
								type: 'fncPopulateUsers',
								context: 1
							});
                        } else {
                            var snackDetails = {color: 'error', message: 'An error occured while trying to import the users', display: true};
                            commit('setSnack', snackDetails);
						}
				});
        });
    });
}

export const fncImportBranches = ({commit, dispatch, state, rootState}, payload) => {
	var objAuthorize = JSON.parse( rootState.objAuthorize );
	var branchDetails = { rows: payload, manufacturer_id: objAuthorize.manufacturer };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Company.php?a=import_branches', {params: branchDetails}, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'An error occured while trying to import the branches', display: true};
			commit('setSnack', snackDetails);
		}).then(data => {
			if( data.result == true ) {
				var snackDetails = {color: 'success', message: 'The branches were imported successfully', display: true};
				commit('setSnack', snackDetails);
				commit('hideModal');
				dispatch({
					type: 'fncPopulateUsers',
					context: 2
				});
        var importResult = 'RESULT' + "\n";
        for( var d in data.imports ) {
          importResult += data.imports[d] + ",";
          importResult += "\n";
        }
        var resultDownload = document.createElement('a');
        resultDownload.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(importResult));
        resultDownload.setAttribute('download', 'import_results.csv');
        resultDownload.click();
			} else {
				var snackDetails = {color: 'error', message: 'An error occured while trying to import the branches', display: true};
				commit('setSnack', snackDetails);
			}
	});
}

export const fncImportCompanies = ({commit, dispatch, state, rootState}, payload) => {
    var objAuthorize = JSON.parse( rootState.objAuthorize );
	var companyDetails = { rows: payload, manufacturer_id: objAuthorize.manufacturer };
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Company.php?a=import_companies', {params: companyDetails}, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            var snackDetails = {color: 'error', message: 'An error occured while trying to import the companies', display: true};
            commit('setSnack', snackDetails);
        }).then(data => {
			if( !data.hasOwnProperty('error') ) {
				var snackDetails = {color: 'success', message: 'The companies were imported successfully', display: true};
				commit('setSnack', snackDetails);
				commit('hideModal');
				dispatch({
					type: 'fncPopulateUsers',
					context: 2
				});

        var importResult = 'RESULT' + "\n";
        for( var d in data ) {
          importResult += data[d] + ",";
          importResult += "\n";
        }
        var resultDownload = document.createElement('a');
        resultDownload.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(importResult));
        resultDownload.setAttribute('download', 'import_results.csv');
        resultDownload.click();

			} else {
				var snackDetails = {color: 'error', message: 'An error occured while trying to import the companies', display: true};
				commit('setSnack', snackDetails);
			}
    });
}

export const fncDeleteUser = ({ commit, dispatch, state, rootState }, payload) => {
	var userDetails = { id: payload.userId };
	if (payload.deleteType == 'company') {
		userDetails = { id: payload.userId };
		Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Company.php?a=delete', { params: userDetails }, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				var snackDetails = { color: 'error', message: 'An error occured while trying to remove the company', display: true };
				commit('setSnack', snackDetails);
			}).then(data => {
				var snackDetails = { color: 'success', message: 'The company was removed successfully', display: true };
				commit('setSnack', snackDetails);
				dispatch({
					type: 'fncPopulateUsers',
					context: payload.context
				});
			});
	} else {
		Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=delete', userDetails, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				var snackDetails = { color: 'error', message: 'An error occured while trying to remove the user', display: true };
				commit('setSnack', snackDetails);
			}).then(data => {
				var snackDetails = { color: 'success', message: 'The user was removed successfully', display: true };
				commit('setSnack', snackDetails);
				dispatch({
					type: 'fncPopulateUsers',
					context: payload.context
				});
			});
	}

}

export const fncSetUserNotifications = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var userDetails = {
		user: payload.userId,
		user_type: payload.context,
	};
	commit('fncEmptyUserNotifications');
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Notification.php?a=get_user_notification_cfg', { params: userDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			commit({
				type: 'setUserNotifications',
				users: data
			});
			/*var modalDetails = { title: 'Communication Settings', component: 'modal-user-notifications', mstate: true, params: { userId: payload.userId } };
			commit({
				type: 'setModal',
				details: modalDetails
			});*/
		});
};

export const fncEditNotifications = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var nfgDetails = {
		user: payload,
        notifications: []
	};
	for ( var k in state.objUserNotifications.users ) {
		var objNfg = { nf_cfg: state.objUserNotifications.users[k].id, get_sms: state.objUserNotifications.users[k].get_sms, get_push: state.objUserNotifications.users[k].get_push, get_email: state.objUserNotifications.users[k].get_email };
		nfgDetails.notifications.push(objNfg);
	}
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Notification.php?a=save_user_notification_cfg', { params: nfgDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The communication settings have been updated successfully', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
		});
};

export const fncUpdateUserPassword = ({ commit, dispatch, state, rootState }, payload) => {
	var userDetails = {
		user: payload.userId,
		email: payload.userEmail
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=request_reset_code', { params: userDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
			var snackDetails = { color: 'error', message: 'There has been an error trying to update the users password', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
		}).then(data => {
			var modalDetails = { title: 'User Password Reset', component: 'modal-user-password', mstate: true, params: { userId: payload.userId, userEmail: payload.userEmail } };
			commit({
				type: 'setModal',
				details: modalDetails
			});
		});
};

export const fncUpdatePassword = ({ commit, dispatch, state, rootState }, payload) => {
	var passwordDetails = {
		user: payload.userId,
		reset_code: payload.resetCode,
        password: payload.newPassword
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=reset_password', { params: passwordDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
			var snackDetails = { color: 'error', message: 'There has been an error trying to update the users password', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
		}).then(data => {
			if (data.msg == 'Success') {
				var snackDetails = { color: 'success', message: 'The users password has been updated successfully', display: true };
				commit('setSnack', snackDetails);
				commit('hideModal');
			} else {
				var snackDetails = { color: 'error', message: 'The incorrect reset code was entered', display: true };
				commit('setSnack', snackDetails);
			}
		});
};

export const fncEditUserPricelist = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			var objAuthorize = JSON.parse(rootState.objAuthorize);
			//var pricelistDetails = { token: data.token, manufacturer_id: objAuthorize.manufacturer, active: 1, is_library_pricelist: 0 };
			var pricelistDetails = { token: data.token, manufacturer_id: objAuthorize.manufacturer, is_library_pricelist: 0 };
			Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: pricelistDetails }, rootState.headerDetails)
				.then(response => {
					return response.json();
				}, error => {
					console.log(error);
				}).then(data => {
					var spinePricelists = data;
					var role_details = { a: 'get_user_plist', id: payload.userId, manufacturer: objAuth.manufacturer };
					Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', { params: role_details }, rootState.headerDetails)
						.then(response => {
							return response.json();
						}, error => {
							console.log(error);
						}).then(d => {
							commit({
								type: 'fncUserPricelists',
								spinePricelists: spinePricelists,
                                userPricelists: d
							});
							if (payload != undefined && payload.showPop == undefined) {
								var modalDetails = { title: 'Specific User Pricelists', component: 'modal-user-pricelists', mstate: true, params: { userId: payload.userId } };
								commit({
									type: 'setModal',
									details: modalDetails
								});
							}
						});
				});
		});
}

export const fncEditPricelists = ({ commit, dispatch, state, rootState }, payload) => {
	var pricelistDetails = {
		id: payload.userId,
		pricelists: []
	};
	for (var k in state.objUserPricelists) {
		if (state.objUserPricelists[k].used == 1) {
          pricelistDetails.pricelists.push({ pricelist_order: parseInt(k)+1, id: state.objUserPricelists[k].pl_id });
		}
	}
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=save_user_pricelist', pricelistDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
			var snackDetails = { color: 'error', message: 'There has been an error trying to update the users pricelists', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
		}).then(data => {
			if (data.hasOwnProperty('msg') && data.msg === 'Success') {
				if (payload != undefined && payload.showSnack == undefined) {
					var snackDetails = { color: 'success', message: 'The user pricelists were updated successfully', display: true };
					commit('setSnack', snackDetails);
					commit('hideModal');
				}
			} else {
				var snackDetails = { color: 'error', message: 'There has been an error trying to update the users pricelists', display: true };
				commit('setSnack', snackDetails);
			}

		});
};

export const fncReorderPricelists = ({ commit, dispatch, state, rootState }, payload) => {
	commit({
		type: 'fncResetPricelists',
		newIndex: payload.end,
		oldIndex: payload.start
	});
	dispatch({
		type: 'fncEditPricelists',
        userId: payload.userId,
		showSnack: false
	})
	commit('fncSetPricelists', state.objUserPricelists);
	dispatch({
		type: 'fncEditUserPricelist',
		userId: payload.userId,
        showPop: false
	})
}

export const fncEditStatus = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var statusDetails = {
		user: payload.userId,
		type: payload.status,
		client_id: objAuth.manufacturer
	};
	Vue.http.get(window.location.protocol + process.env.DEV_ENDPOINT + 'api/v1/documentStatus/user', { params: statusDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
			var snackDetails = { color: 'error', message: 'There has been an error trying to retrieve the user statusses', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
		}).then(data => {
			commit('setObjUserStatus', data);
			if (payload != undefined && payload.showModal == undefined) {
				var modalDetails = { title: 'User Status Management', component: 'modal-user-status', mstate: true, params: { userId: payload.userId } };
				commit({
					type: 'setModal',
					details: modalDetails
				});
			}
		});
};

export const fncUpdateUserStatus = ({ commit, dispatch, state, rootState }, payload) => {
	var statusDetails = {
		user: payload,
		statuses: []
	};
	for ( var k in state.objUserStatus ) {
		if (state.objUserStatus[k].excluded == 0) {
			statusDetails.statuses.push(state.objUserStatus[k].id);
		}
	}
	Vue.http.post(window.location.protocol + process.env.DEV_ENDPOINT + 'api/v1/documentStatus/user', statusDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
			var snackDetails = { color: 'error', message: 'There has been an error trying to update the user statusses', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The user statuses were updated successfully', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
		});
};

export const fncEditUserCompanies = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var companyDetails = {
		manufacturer: objAuth.manufacturer,
		type: payload.listType
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Company.php?a=get_companies', { params: companyDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
			var snackDetails = { color: 'error', message: 'There has been an error trying to retrieve the company list', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
		}).then(data => {
			var modalDetails = { title: 'User Company Assignment', component: 'modal-user-company', mstate: true, params: { userId: payload.userId, context: payload.context } };
			commit({
				type: 'setModal',
				details: modalDetails
			});
			commit('setObjUserCompanies', data);
		});
};

export const fncUpdateUserCompany = ({ commit, dispatch, state, rootState }, payload) => {
	var companyDetails = {
		user: payload.userId,
		company : payload.company
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=user_assign_company', { params: companyDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
			var snackDetails = { color: 'error', message: 'There has been an error trying to update the users company', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
		}).then(data => {
			commit('fncEmptyUsers', payload.context);
			var snackDetails = { color: 'success', message: 'The users company has been updated successfully', display: true };
			commit('setSnack', snackDetails);
			dispatch({
				type: 'fncPopulateUsers',
                context: payload.context
			})
			commit('hideModal');
		});
};

export const fncViewCompany = ({ commit, dispatch, state, rootState }, payload) => {
	var companyDetails = {
		params: {
			id: payload
		}
	};
	Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Company.php?a=get_company_data', { params: companyDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
			var snackDetails = { color: 'error', message: 'There has been an error trying to retrieve the company details', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
		}).then(data => {
			commit('setCurrentCompany', data);
			var modalDetails = { title: 'Company Details', component: 'modal-user-company-details', mstate: true, params: { companyId: payload } };
			commit({
				type: 'setModal',
				details: modalDetails
			});
		});
};

export const fncLoadCompany = ({ commit, dispatch, state, rootState }, payload) => {
	var companyDetails = {
		params: {
			id: payload
		}
	};
	Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Company.php?a=get_company_data', { params: companyDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
			var snackDetails = { color: 'error', message: 'There has been an error trying to retrieve the company details', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
		}).then(data => {
			commit('fncSetObjCompanyEdit', data);
			/*var modalDetails = { title: 'Company Details', component: 'modal-user-company-details', mstate: true, params: { companyId: payload } };
			commit({
				type: 'setModal',
				details: modalDetails
			});*/
		});
};

export const fncViewUser = ({ commit, dispatch, state, rootState }, payload) => {
	var userDetails = {
		id: payload.userId,
		ctx: process.env.CTX
	};
	Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'users_tree_data_handler.php?a=get_user_data', { params: userDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
			var snackDetails = { color: 'error', message: 'There has been an error trying to retrieve the user details', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
		}).then(data => {

			var objAuth = JSON.parse(rootState.objAuthorize);
			var locationDetails = {
              manufacturer: objAuth.manufacturer
			};
			Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Location.php?a=get_all', { params: locationDetails }, rootState.headerDetails)
				.then(response => {
					return response.json();
				}, error => {
					console.log(error);
					var snackDetails = { color: 'error', message: 'There has been an error trying to retrieve the user locations', display: true };
					commit('setSnack', snackDetails);
					commit('hideModal');
				}).then(d => {
					Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
						.then(response => {
							return response.json();
						}, error => {
							console.log(error);
						}).then(dd => {
							var objAuthorize = JSON.parse(rootState.objAuthorize);
							var pricelistDetails = { token: dd.token, manufacturer_id: objAuthorize.manufacturer };
							Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: pricelistDetails }, rootState.headerDetails)
								.then(response => {
									return response.json();
								}, error => {
									console.log(error);
								}).then(pricelists => {
									commit({
										type: 'setCurrentUser',
										userData: data,
										regionData: d,
										regions: payload.regions,
                                        pricelists: pricelists
									})
									var modalDetails = { title: 'User Details', component: 'modal-user-details', mstate: true, params: { companyId: payload } };
									commit({
										type: 'setModal',
										details: modalDetails
									});
								});
						});
				});
		});
};

export const fncOverrideSettings = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var userDetails = {
		a: 'get_qa_override',
		params: {
			manufacturer: objAuth.manufacturer,
			user: objAuth.id,
		}
	};
	Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'User.php', { params: userDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			commit('setOverrideSettings', data);
			var modalDetails = { title: 'Override Document Access', component: 'modal-doc-override', mstate: true, params: {} };
			commit({
				type: 'setModal',
				details: modalDetails
			});
		});
};

export const fncSaveOverrideSettings = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var docDetails = {
		accessorUserId: payload.userId,
		accesseeUserId: objAuth.id
	};
	var action = 'add_user_override';
	if (payload.override == 'remove' ) {
		action = 'remove_user_override';
	}
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=' + action, { params: docDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
			var snackDetails = { color: 'error', message: 'There has been an error trying to update the doc override settings', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The doc override settings have been updated successfully', display: true };
			commit('setSnack', snackDetails);
		});
};

export const fncFetchLinkUsers = ({ commit, dispatch, state, rootState }, payload) => {
	var linkDetails = {
		a: 'get_lu_user_list',
		params: {
			user: payload.userId,
			uu_type: payload.userType,
			lu_type: payload.userType,
			link_dir: 1,
            deleted: 0
		}
	};
	Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'User.php', { params: linkDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			commit('setUserLinks', data);
		});
};

export const fncSaveUserLink = ({ commit, dispatch, state, rootState }, payload) => {
	var action = 'link_user';
	if (payload.linkType == 'unlink') {
		action = 'unlink_user';
	}
	var linkDetails = {
		a: action,
		params: {
			linkType: payload.saveType,
			parent: payload.parent,
            child: payload.child
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php', linkDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'There has been an error trying to link the user', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
        }).then(data => {
            if ( data.error ) {
                var snackDetails = { color: 'error', message: data.error, display: true };
                commit('setSnack', snackDetails);
            } else {
                if (action == 'link_user') {
                    var snackDetails = { color: 'success', message: 'The user has been linked successfully', display: true };
                } else {
                    var snackDetails = { color: 'success', message: 'The user has been unlinked successfully', display: true };
                }
                commit('setSnack', snackDetails);
                dispatch({
                    type: 'fncPopulateUsers',
                    context: payload.userType
                });
            }
		});
};

export const fncSetupUserCreate = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var roleDetails = {
		a: 'get_user_roles',
		params: {
			user_type: 1,
			user: null,
            manufacturer: objAuth.manufacturer
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Role.php', roleDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			commit('fncSetUserRoles', data);
			commit('fncSetUserCompanies', '');

      commit('fncSetUserLoading', false);

			if (payload == 'user') {
				/*var modalDetails = { title: 'Create User', component: 'modal-user-create', mstate: true, params: {} };
				commit({
					type: 'setModal',
					details: modalDetails
				});*/
			} else if( payload == 'company' ) {
				var modalDetails = { title: 'Create Company', component: 'modal-company-create', mstate: true, params: {} };
				commit({
					type: 'setModal',
					details: modalDetails
				});
			}
		});
};

export const fncResetSetupUserCreate = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var roleDetails = {
		a: 'get_user_roles',
		params: {
			user_type: payload.userType,
			user: null,
			manufacturer: objAuth.manufacturer
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Role.php', roleDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			commit('fncSetUserRoles', data);
			var companyDetails = {
				a: 'get_companies',
				params: {
					type: payload.companyType,
					manufacturer: objAuth.manufacturer
				}
			};
			Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Company.php', companyDetails, rootState.headerDetails)
				.then(response => {
					return response.json();
				}, error => {
					console.log(error);
				}).then(dd => {
					commit('fncSetUserCompanies', dd);
				});
		});
};

export const fncSetBranchesDepartments = ({ commit, dispatch, state, rootState }, payload) => {
  var userDetails = {user: payload};
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Department.php?a=getUserDepartmentBranches', userDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
      commit('setUserBranchesDepartments', data);
  });

}


/*export const fncSetEditUserPublic = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var userDetails = {
      a: 'expand_user_tree_single',
      context: 4,
      user_id: payload.id,
      manufacturer: objAuth.manufacturer
  };

  alert('ja???');

  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'users_tree_data_handler.php', { params: userDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
      console.log('Data');
      console.log( data );
      commit('setUserBranchesDepartments',data);
    }).then(u => {

      var objAuth = JSON.parse(rootState.objAuthorize);
      var roleDetails = {
        a: 'get_user_roles',
        params: {
          user_type: 4,
          user: payload.id,
          manufacturer: objAuth.manufacturer
        }
      };
      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Role.php', roleDetails, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          console.log(error);
        }).then(data => {

        commit('fncSetUserRoles', data);
        u.user_role = '';
        for ( var d in data ) {
          if ( data[d].user_role_count == '1' ) {
            u.user_role = data[d].id;
          }
        }
        commit('fncSetObjUserEdit', u);
        if (payload.type != 1) {
          var type = 2;
          if (payload.type == 2) { type = 1; }
          var companyDetails = {
            a: 'get_companies',
            params: {
              type: type,
              manufacturer: objAuth.manufacturer
            }
          };
          Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Company.php', companyDetails, rootState.headerDetails)
            .then(response => {
              return response.json();
            }, error => {
              console.log(error);
            }).then(dd => {
            commit('fncSetUserCompanies', dd);
          });
        } else {
          commit('fncSetUserCompanies', '');
        }

        dispatch('fncPopulateUserRegions');
        dispatch('fncSetupUserCreate', '');
        var modalDetails = { title: 'Update User - ' + payload.name + ' ' + payload.surname, component: 'modal-user-edit', mstate: true, params: {} };
        commit({
          type: 'setModal',
          details: modalDetails
        });
      });

  });
};*/

export const fncSetEditUserPublic = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var userDetails = {
    a: 'expand_user_tree_single',
    context: 4,
    user_id: payload.id,
    manufacturer: objAuth.manufacturer
  };

  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'users_tree_data_handler.php', { params: userDetails }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(u => {

    var objAuth = JSON.parse(rootState.objAuthorize);
    var roleDetails = {
      a: 'get_user_roles',
      params: {
        user_type: 4,
        user: payload.id,
        manufacturer: objAuth.manufacturer
      }
    };
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Role.php', roleDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        console.log(error);
      }).then(data => {

      commit('fncSetUserRoles', data);
      u.user_role = '';
      for ( var d in data ) {
        if ( data[d].user_role_count == '1' ) {
          u.user_role = data[d].id;
        }
      }
      commit('fncSetObjUserEdit', u);
      if (payload.type != 1) {
        var type = 2;
        if (payload.type == 2) { type = 1; }
        var companyDetails = {
          a: 'get_companies',
          params: {
            type: type,
            manufacturer: objAuth.manufacturer
          }
        };
        Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Company.php', companyDetails, rootState.headerDetails)
          .then(response => {
            return response.json();
          }, error => {
            console.log(error);
          }).then(dd => {
          commit('fncSetUserCompanies', dd);
        });
      } else {
        commit('fncSetUserCompanies', '');
      }

      dispatch('fncPopulateUserRegions');
      dispatch('fncSetupUserCreate', '');
      var modalDetails = { title: 'Update User - ' + payload.name + ' ' + payload.surname, component: 'modal-user-edit', mstate: true, params: {} };
      commit({
        type: 'setModal',
        details: modalDetails
      });
    });

    console.log( u );
  });
};

export const fncSetEditUser = ({ commit, dispatch, state, rootState }, payload) => {

	var objAuth = JSON.parse(rootState.objAuthorize);
	var roleDetails = {
		a: 'get_user_roles',
		params: {
			user_type: payload.type,
			user: payload.id,
			manufacturer: objAuth.manufacturer
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Role.php', roleDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			commit('fncSetUserRoles', data);
			payload.user_role = '';
			for ( var d in data ) {
				if ( data[d].user_role_count == '1' ) {
					payload.user_role = data[d].id;
				}
			}
			commit('fncSetObjUserEdit', payload);
			if (payload.type != 1) {
				var type = 2;
				if (payload.type == 2) { type = 1; }
				var companyDetails = {
					a: 'get_companies',
					params: {
						type: type,
						manufacturer: objAuth.manufacturer
					}
				};
				Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Company.php', companyDetails, rootState.headerDetails)
					.then(response => {
						return response.json();
					}, error => {
						console.log(error);
					}).then(dd => {
						commit('fncSetUserCompanies', dd);
					});
			} else {
				commit('fncSetUserCompanies', '');
			}
			var modalDetails = { title: 'Update User - ' + payload.name + ' ' + payload.surname, component: 'modal-user-edit', mstate: true, params: {} };
			commit({
				type: 'setModal',
				details: modalDetails
			});
		});
};

export const fncPopulateUserRegions = ({ commit, dispatch, state, rootState }) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var regionDetails = { params: { manufacturer: objAuth.manufacturer } };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Location.php?a=get_all_full', regionDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error occured while retrieving the region list', display: true };
		}).then(data => {
			setTimeout(function () {
				commit('setUserRegions', data);
			}, 1000)
		});
}

export const fncCreateCompany = ({ commit, dispatch, state, rootState }, payload) => {
	var region = '';
	for (var c in state.userRegions) {
		if (state.userRegions[c].selected == true) {
			region = state.userRegions[c];
		}
		for (var p in state.userRegions[c].children) {
			if (state.userRegions[c].children[p].selected == true) {
				region = state.userRegions[c].children[p];
			}
			for (var t in state.userRegions[c].children[p].children) {
				if (state.userRegions[c].children[p].children[t].selected == true) {
					region = state.userRegions[c].children[p].children[t];
				}
			}
		}
	}
	var objAuth = JSON.parse(rootState.objAuthorize);
	var companyDetails = {
		type: payload.companyType.id,
		customer_code: payload.customerCode,
		registration_no: payload.registrationNo,
		vat_no: payload.vatNo,
		name: payload.name,
		trading_name: payload.tradingName,
		address_1: payload.addressLine1,
		address_2: payload.addressLine2,
		postal_code: payload.postalCode,
		contact_no: payload.contactNo,
		fax_no: payload.faxNumber,
		email: payload.email,
		contact: 0,
		notes: payload.notes,
		region: region.loc_id,
		created_by: objAuth.id,
		manufacturer: objAuth.manufacturer
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Company.php?a=create', { params: companyDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
			var snackDetails = { color: 'error', message: 'An error occured while trying to create the company', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			if (data.msg == 'success') {
				var snackDetails = { color: 'success', message: 'The company has been successfully created', display: true };
				commit('setSnack', snackDetails);
				dispatch({
					type: 'fncPopulateUsers',
					context: 2
				});
				commit('hideModal');
			} else {
				var snackDetails = { color: 'error', message: 'An error occured while trying to create the company', display: true };
				commit('setSnack', snackDetails);
			}
		});
}

export const fncUpdateCompany = ({ commit, dispatch, state, rootState }, payload) => {
	var region = '';
	for (var c in state.userRegions) {
		if (state.userRegions[c].selected == true) {
			region = state.userRegions[c];
		}
		for (var p in state.userRegions[c].children) {
			if (state.userRegions[c].children[p].selected == true) {
				region = state.userRegions[c].children[p];
			}
			for (var t in state.userRegions[c].children[p].children) {
				if (state.userRegions[c].children[p].children[t].selected == true) {
					region = state.userRegions[c].children[p].children[t];
				}
			}
		}
	}

	console.log('payload');
	console.log( payload );

	var objAuth = JSON.parse(rootState.objAuthorize);
	var companyDetails = {
        id: payload.details.id,
		type: payload.context,
		customer_code: payload.details.customer_code,
		registration_no: payload.details.registration_no,
		vat_no: payload.details.vat_no,
		name: payload.details.name,
		trading_name: payload.details.trading_name,
		address_1: payload.details.address_1,
		address_2: payload.details.address_2,
		postal_code: payload.details.postal_code,
		contact_no: payload.details.contact_no,
		fax_no: payload.details.fax_no,
		email: payload.details.email,
		contact: 0,
		notes: payload.details.notes,
		region: region.loc_id,
		created_by: objAuth.id,
		manufacturer: objAuth.manufacturer,
        delId: payload.details.delId,
        delAddress: payload.details.delAddress,
        delPostalCode: payload.details.delPostalCode,
		linked_stores: payload.details.linked_store
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Company.php?a=edit', { params: companyDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error occured while trying to update the company 1', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			if (data.msg == 'success') {
				var snackDetails = { color: 'success', message: 'The company has been successfully updated', display: true };
				commit('setSnack', snackDetails);
				var newContext = 2;
				if ( payload.context == 2 ) {
					newContext = 3;
				}
				dispatch({
					type: 'fncPopulateUsers',
					context: newContext
				});
				commit('hideModal');
			} else {
				var snackDetails = { color: 'error', message: 'An error occured while trying to update the company 2', display: true };
				commit('setSnack', snackDetails);
			}
		});
}

export const fncCreateUser = ({ commit, dispatch, state, rootState }, payload) => {
	var regions = [];
	for (var c in state.userRegions) {
		if (state.userRegions[c].selected == true) {
			regions.push(state.userRegions[c].loc_id);
		}
		for (var p in state.userRegions[c].children) {
			if (state.userRegions[c].children[p].selected == true) {
				regions.push(state.userRegions[c].children[p].loc_id);
			}
			for (var t in state.userRegions[c].children[p].children) {
				if (state.userRegions[c].children[p].children[t].selected == true) {
					regions.push(state.userRegions[c].children[p].children[t].loc_id);
				}
			}
		}
	}
	var selectedRegions = regions;
	var pricelists = [];
	var objAuth = JSON.parse(rootState.objAuthorize);
	Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			var objAuthorize = JSON.parse(rootState.objAuthorize);
			var pricelistDetails = { token: data.token, manufacturer_id: objAuthorize.manufacturer, default: 1 };
			Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: pricelistDetails }, rootState.headerDetails)
				.then(response => {
					return response.json();
				}, error => {
					console.log(error);
				}).then(data => {
					for (var k in data) {
						pricelists.push(data[k].pl_id);
					}
					var userRoles = [];
					userRoles.push(payload.userRole);
          let is_lead_create
          if (payload.hasOwnProperty('is_lead_create')){
            is_lead_create = 1
          }
          else {
            is_lead_create = 0
          }

					var userDetails = {
						region_contact: payload.regionContact == true ? 1 : 0,
						active: payload.activeMyorder == true ? 1 : 0,
						sendConfirmation: payload.sendConfirmation == true ? 1 : 0,
						type: payload.userType,
						name: payload.firstName,
						surname: payload.surname,
						contactno: payload.contactNo,
						alt_contactno: payload.alternativeContactNo,
						regions_added: selectedRegions,
						email: payload.username,
						pwd: payload.password,
						vat_no: payload.vatNo,
						company: payload.userCompany == '0' ? '' : payload.userCompany,
						retailer: '1000000',
						user_roles: userRoles,
						discount_max: payload.maxDiscount,
						discount_def: payload.defaultDiscount,
						inc_max: payload.maxIncidentalValue,
						contri_min: payload.contributionMinimum,
						contri_default: payload.contributionMinimum,
						auto_link: payload.linkUser == true ? 1 : 0,
						pl: pricelists,
						manufacturer: objAuth.manufacturer,
						current_user: objAuth.id,
            vendor: payload.userVendor,
            branch: payload.userBranch,
            department: payload.userDepartment,
            vendor: payload.userVendor,
            reference: payload.userReference,
            is_responsible_department_branch: payload.userResponsibleRep == true ? 1 : 0,
            is_commercial_kam: payload.commercialKam == true ? 1 : 0,
            is_commercial_originator: payload.commercialOriginator == true ? 1 : 0,
            branchesDepartments: payload.branchesDepartments,
            myorder: true,
            is_lead_create: is_lead_create,
            linkedBranches: payload.linkedBranches,
			avatar: payload.avatar,
			trade_customer: payload.tradeCustomer,
			gp_manipulation: payload.gpManipulation,
			gp_manipulation_percentage: payload.gpManipulationPercentage
					};
					Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=create', { params: userDetails }, rootState.headerDetails)
						.then(response => {
							return response.json();
						}, error => {
							console.log(error);
							var snackDetails = { color: 'error', message: 'An error occured while trying to create the user', display: true };
							commit('setSnack', snackDetails);
						}).then(data => {
						  console.log('Test');
						  console.log(data);
							if (data.hasOwnProperty('error')) {
						      var snackDetails = { color: 'error', message: data.error, display: true };
						      commit('setSnack', snackDetails);
							}
              else if (data.hasOwnProperty('is_lead_create')) {

                var user = { manu: objAuth.manufacturer };
                Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Branch.php?a=get_users', user, rootState.headerDetails)
                  .then(response => {
                    return response.json();
                  }, error => {
                    console.log(error);
                  }).then(re => {
                  var snackDetails = { color: 'success', message: 'The user has been successfully created', display: true };
                  commit('setSnack', snackDetails);
                  commit('fncLeadUserSelected', data.id);
                  commit('fncNewLeadUsers', re.users);
                })

              }
              else {
								var snackDetails = { color: 'success', message: 'The user has been successfully created', display: true };
								commit('setSnack', snackDetails);
                setTimeout(function () {
                  //location.reload();
                }, 1000)
								/*dispatch({
									type: 'fncPopulateUsers',
									context: payload.userType
								});*/
								commit('hideModal');
							}
						});
				});
		});
}

export const fncUpdateUser = ({ commit, dispatch, state, rootState }, payload) => {

	var regions = [];
	var regionsRemoved = [];
	for (var c in state.userRegions) {
		if (state.userRegions[c].selected == true) {
			regions.push(state.userRegions[c].loc_id);
		}
		if (state.userRegions[c].oldSelected == true) {
			regionsRemoved.push(state.userRegions[c].loc_id);
		}
		for (var p in state.userRegions[c].children) {
			if (state.userRegions[c].children[p].selected == true) {
				regions.push(state.userRegions[c].children[p].loc_id);
			}
			if (state.userRegions[c].children[p].oldSelected == true) {
				regionsRemoved.push(state.userRegions[c].children[p].loc_id);
			}
			for (var t in state.userRegions[c].children[p].children) {
				if (state.userRegions[c].children[p].children[t].selected == true) {
					regions.push(state.userRegions[c].children[p].children[t].loc_id);
				}
				if (state.userRegions[c].children[p].children[t].oldSelected == true) {
					regionsRemoved.push(state.userRegions[c].children[p].children[t].loc_id);
				}
			}
		}
	}
	var userRoles = [];
	    userRoles.push( payload.user_role );
		var objAuth = JSON.parse(rootState.objAuthorize);
		/*if (isNaN(payload.vendor) ) {
			payload.vendor = '';
		}*/

	var userDetails = {
		id: payload.id,
		region_contact: payload.region_contact == true || payload.region_contact == 1 ? 1 : 0,
		active: payload.active == true ? 1 : 0,
		type: payload.type,
		name: payload.name,
		surname: payload.surname,
		contactno: payload.contactno,
		alt_contactno: payload.alt_contactno,
		email: payload.email,
		vat_no: payload.vat_no,
		company: payload.company == '0' ? '' : payload.company,
		retailer: payload.retailer,
		user_roles: userRoles,
		discount_max: payload.discount_max,
		discount_def: payload.discount_def,
		inc_max: payload.inc_max,
		contri_min: payload.contri_min,
		contri_default: payload.contri_default,
		auto_link: payload.autolink == true ? 1 : 0,
		manufacturer: objAuth.manufacturer,
		userid: objAuth.id,
    vendor: payload.vendor,
    reference: payload.reference,
    /*branch_id: payload.branch_id,
    department: payload.department,*/
    is_responsible_department_branch: payload.is_responsible_department_branch,
    is_commercial_kam: payload.is_commercial_kam == true ? 1 : 0,
    is_commercial_originator: payload.is_commercial_originator == true ? 1 : 0,
    regions_added: regions,
    regions_removed: regionsRemoved,
    branchesDepartments: JSON.stringify(payload.branchesDepartments),
    linkedBranches: payload.linkedBranches,
	avatar: payload.avatar,
	is_trade_customer: payload.is_trade_customer,
	gp_manipulation: payload.gp_manipulation,
	gp_manipulation_percentage: payload.gp_manipulation_percentage
	};

	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=edit', { params: userDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
			var snackDetails = { color: 'error', message: 'An error occured while trying to update the user', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			if (data.hasOwnProperty('error')) {
				var snackDetails = { color: 'error', message: data.error, display: true };
				commit('setSnack', snackDetails);
			} else {
				var snackDetails = { color: 'success', message: 'The user has been successfully updated', display: true };
				commit('setSnack', snackDetails);
				/*dispatch({
					type: 'fncPopulateUsers',
					context: payload.type
				});*/
        setTimeout(function () {
          location.reload();
        }, 1000)
				commit('hideModal');
			}
		});
}

export const fncPopulateUserVendors = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var vendorDetails = { a: 'getAll', manu: objAuth.manufacturer };
	Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php', { params: vendorDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			commit('setUserVendors', data);
		});
}

export const fncUpdateQuoteReps = ({ commit, dispatch, state, rootState }, payload) => {

  var objDetails = { a: 'updateQuoteReps', quoteId: payload.id, reps: payload.new_responsible_reps_ids_obj }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', objDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
      if( data == true ) {
        var snackDetails = { color: 'success', message: 'The users linked to the quote has been updated', display: true };
        commit('setSnack', snackDetails);
        setTimeout(function() {
          location.reload();
        }, 1000)
      }
  });
}

export const fncUpdateQuoteRepsSwitch = ({ commit, dispatch, state, rootState }, payload) => {

  var objDetails = { a: 'updateQuoteReps', quoteId: payload.id, reps: payload.new_responsible_reps_ids_obj }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', objDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    if( data == true ) {
      var snackDetails = { color: 'success', message: 'The users linked to the quote has been updated', display: true };
      commit('setSnack', snackDetails);
    }
  });
}

export const fncPopulateSurveys = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  var surveyDetails = { a: 'getSurveys', manu: objAuth.manufacturer };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', surveyDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

      commit( 'fncSetSurveyList', data );

  });
}

export const fncGetSurveyDocEdits = ({ commit, dispatch, state, rootState }, payload) => {

  var surveyDetails = { a: 'getSurveyEdit', quoteId: payload };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', surveyDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

    var modalDetails = { title: 'Edit Survey Doc', component: 'modal-survey-document', mstate: true, params: { surveyData: data } };
    commit({
      type: 'setModal',
      details: modalDetails
    });
      // commit( 'fncSetSurveyList', data );

  });
}

export const fncGeQuoteDetails = ({ commit, dispatch, state, rootState }, payload) => {

  var surveyDetails = { a: 'getSurveyEdit', quoteId: payload.quoteId };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', surveyDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

      // get branch id here
    var objAuth = JSON.parse(rootState.objAuthorize);
    var qtote = { quote_id: payload.quoteId, manu: objAuth.manufacturer };
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Branch.php?a=get_branch', qtote, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        console.log(error);
      }).then(re => {

      // commit('setBranch', data);
        var modalDetails = { title: 'Clone Quote', component: 'modal-clone-quote', mstate: true, params: { quoteData: data, quote_id: re.branch_id, users: re.users, customer: re.customer, departmentId: payload.departmentId, project: data.project, survey_company: data.survey_company} };
        commit({
          type: 'setModal',
          details: modalDetails
        });

    });

  });
}
export const fncGeLeadDetails = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  var qtote = { manu: objAuth.manufacturer };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Branch.php?a=get_users', qtote, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(re => {

    // commit('setBranch', data);
    var modalDetails = { title: 'Create New Lead', component: 'modal-create-new-lead', mstate: true, params: { departments: re.department,statuses: re.statuses, role: re.role } };
    commit('fncNewLeadUsers', re.users);
    commit({
      type: 'setModal',
      details: modalDetails
    });
    })
}

export const fncCreateNewLeadQuote = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var obj = { a: 'create_new_lead',
    user: payload.user,
    lead_description: payload.lead_description,
    lead_status: payload.lead_status,
    department: payload.department,
    manu: objAuth.manufacturer,
    auth_user: objAuth.id,
    project : payload.project,
    company: payload.company,
    branch: payload.branch,
  }

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', obj, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    if( data == true ) {
      var snackDetails = { color: 'success', message: 'The new lead has been successfully created', display: true };
      commit('setSnack', snackDetails);
      setTimeout(function() {
        location.reload();
      }, 1000)
    }
    else {
      var snackDetails = {color: 'error', message: 'Creating the new lead failed', display: true};
    }
    commit('setSnack', snackDetails);
  });
}

export const fncGetSurveyDocDownload = ({ commit, dispatch, state, rootState }, payload) => {

  var surveyDetails = { a: 'getSurveyEdit', quoteId: payload.quoteId };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', surveyDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

      var customerAddress = '';

      if( data.customer_address != '' ) { customerAddress += '<br />' + data.customer_address; }
      if( data.customer_address_two != '' ) { customerAddress += '<br />' + data.customer_address_two; }
      if( data.customer_suburb != '' ) { customerAddress += '<br />' + data.customer_suburb; }
      if( data.customer_town != '' ) { customerAddress += '<br />' + data.customer_town; }
      if( data.customer_province != '' ) { customerAddress += '<br />' + data.customer_province; }
      if( data.customer_postal_code != '' ) { customerAddress += '<br />' + data.customer_postal_code; }

      if( customerAddress == '' ) { customerAddress = 'N/A'; }

      var kamUser = 'N/A';
      for( var u in payload.users ) {
        if( payload.users[u].id == data.store_info_kam ) {
          kamUser = payload.users[u].fullname;
        }
      }

      var branch = 'N/A';
      for( var b in payload.branches ) {
        if( payload.branches[b].id == data.store_info_branch ) {
          branch = payload.branches[b].name;
        }
      }

      var processData = JSON.parse( data.process_data );
      var htmlAdd = '';

      // payload.formType

      for( var t in processData.tabs ) {

        var displayTab = true;
        if( payload.formType == 'client' && processData.tabs[t].is_client == 'false' ) {
          displayTab = false;
        }

        if( displayTab == true ) {
          htmlAdd += '<table width="100%">';
          htmlAdd += '<tr>';
          htmlAdd += '<td colspan="4" style="font-weight: bold; border-bottom: 1px solid #f1f1f1; text-align: left;padding:10px 10px 0 5px;font-size: 12px;">'+processData.tabs[t].name.toUpperCase()+'</td>';
          htmlAdd += '</tr>';

          htmlAdd += '<tr>';
          var n = 0;



          for( var f in processData.tabs[t].form ) {
            htmlAdd += '<td width="25%"  style="padding: 5px;font-size: 8px;font-weight:bold;">'+processData.tabs[t].form[f].label+':</td>';
            var cellValue = processData.tabs[t].form[f].value;
            if( cellValue == 'false' ){ cellValue = 'No'; }
            if( cellValue == 'true' ){ cellValue = 'Yes'; }
            if( cellValue == '' ){ cellValue = 'N/A'; }
            htmlAdd += '<td width="25%" style="padding: 5px;font-size: 8px;">'+cellValue+'</td>';
            n++;
            if( n%2 == 0 ) {
              htmlAdd += '</tr><tr>';
            }
          }
          htmlAdd += '</tr>';

          htmlAdd += '</table><br />';
        }

      }

      var surveyType = 'Lead';
      if( data.survey_type == '2' ) { surveyType = 'Quote Request'; }
      if( data.survey_type == '3' ) { surveyType = 'Onsite Visit'; }

      var html = '<!DOCTYPE html>\n' +
        '\t<html>\n' +
        '\t\t<body>\n' +
        '\t\t\t<table width="100%">\n' +
        '\t\t\t\t<tr>\n' +
        '\t\t\t\t\t<td width="50%" valign="top" style="font-size: 10px;line-height: 14px;text-align: left;">\n' +
        '\t\t\t\t\t\t<strong>Kam User:</strong> '+kamUser+'<br />\n' +
        '\t\t\t\t\t\t<strong>Branch:</strong> '+ branch +'<br />\n' +
        '\t\t\t\t\t\t<strong>Survey Type:</strong> '+ surveyType +'<br />\n' +
        '\t\t\t\t\t\t<strong>Quote Number:</strong> '+ payload.quoteNo +'<br /><br />\n' +
        '\t\t\t\t\t\t<strong style="font-size: 20px;">Client Request Form</strong><br />\n' +
        /* '\t\t\t\t\t\t<strong>Date:</strong> '+ data.created.substr(0, 10) +'\n' + */
        '\t\t\t\t\t</td>\n' +
        '\t\t\t\t\t<td width="50%" style="text-align: right;"><img src="https://www.builders.co.za/_ui/responsive/theme-yellow/images/Builders-responsive.jpg" width="28%" /></td>\t\t\t\n' +
        '\t\t\t\t</tr>\n' +
        '\t\t\t<table>\n' +
        '\t\t\t<br />\n' +
        '\t\t\t<table width="100%">\n' +
        '\t\t\t\t<tr>\n' +
        '\t\t\t\t\t<td colspan="3" style="font-weight: bold; text-align: left;background: #000; color: #fff;padding: 10px;padding-left: 5px;font-size: 12px;">CLIENT INFO</td>\n' +
        '\t\t\t\t</tr>\n' +
        '\t\t\t\t<tr>\n' +
        '\t\t\t\t\t<td width="33.33%" style="border-bottom: 1px solid #000;padding: 5px;font-size: 8px;font-weight:bold;">Name</td>\n' +
        '\t\t\t\t\t<td width="33.33%" style="border-bottom: 1px solid #000;padding: 5px;font-size: 8px;font-weight:bold;">Contact Person Name</td>\n' +
        '\t\t\t\t\t<td width="33.33%" style="border-bottom: 1px solid #000;padding: 5px;font-size: 8px;font-weight:bold;">Contact Person Cell</td>\n' +
        '\t\t\t\t</tr>\n' +
        '\t\t\t\t<tr>\n' +
        '\t\t\t\t\t<td width="33.33%" style="padding: 5px;font-size: 8px; ">'+data.client_info_co_name+'</td>\n' +
        '\t\t\t\t\t<td width="33.33%" style="padding: 5px;font-size: 8px; ">'+data.client_info_contact+'</td>\n' +
        '\t\t\t\t\t<td width="33.33%" style="padding: 5px;font-size: 8px; ">'+data.client_info_cell+'</td>\n' +
        '\t\t\t\t</tr>\n' +
        '\t\t\t\t<tr>\n' +
        '\t\t\t\t\t<td width="33.33%" style="border-bottom: 1px solid #000;padding: 5px;font-size: 8px;font-weight:bold;">Acc No</td>\n' +
        '\t\t\t\t\t<td width="33.33%" style="border-bottom: 1px solid #000;padding: 5px;font-size: 8px;font-weight:bold;">Message</td>\n' +
        '\t\t\t\t\t<td width="33.33%" style="border-bottom: 1px solid #000;padding: 5px;font-size: 8px;font-weight:bold;">Email</td>\n' +
        '\t\t\t\t</tr>\n' +
        '\t\t\t\t<tr>\n' +
        '\t\t\t\t\t<td width="33.33%" style="padding: 5px;font-size: 8px;">'+data.client_info_acc_no+'</td>\n' +
        '\t\t\t\t\t<td width="33.33%" style="padding: 5px;font-size: 8px;">'+data.client_message+'</td>\n' +
        '\t\t\t\t\t<td width="33.33%" style="padding: 5px;font-size: 8px;">'+data.client_info_email+'</td>\n' +
        '\t\t\t\t</tr>\n' +
        '\t\t\t\t<tr>\n' +
        '\t\t\t\t\t<td width="33.33%" style="border-bottom: 1px solid #000;padding: 5px;font-size: 8px;font-weight:bold;">Tel</td>\n' +
        '\t\t\t\t\t<td width="33.33%" style="border-bottom: 1px solid #000;padding: 5px;font-size: 8px;font-weight:bold;">Fax</td>\n' +
        '\t\t\t\t</tr>\n' +
        '\t\t\t\t<tr>\n' +
        '\t\t\t\t\t<td width="33.33%" style="padding: 5px;font-size: 8px;">'+data.client_info_tel+'</td>\n' +
        '\t\t\t\t\t<td width="33.33%" style="padding: 5px;font-size: 8px;">'+data.client_info_fax+'</td>\n' +
        '\t\t\t\t</tr>\n' +
        '\t\t\t</table>\n' +
        '\t\t\t<br />\n' + htmlAdd +
        '\t\t\t<br />\n' +
        '\t\t</body>\n' +
        '\t</html>';

        html = '<!DOCTYPE html>\n' +
          '<html>\n' +
          '<head>\n' +
          '    <!-- JONIE ADD FONT -->\n' +
          '    <link rel="preconnect" href="https://fonts.googleapis.com/">\n' +
          '    <link rel="preconnect" href="https://fonts.gstatic.com/" crossorigin="">\n' +
          '    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet">\n' +
          '    <!-- JONIE ADDED STYLE -->\n' +
          '    <style type="text/css">\n' +
          '        body {font-family: "Roboto" !important;text-rendering: geometricPrecision !important;}\n' +
          '        table {width: 100%;margin: 0 auto;max-width: 530px;min-width: 530px;}\n' +
          '        td {vertical-align: top;}\n' +
          '    </style>\n' +
          '</head>\n' +
          '<body>\n' +
          '<table width="100%">\n' +
          '    <tr>\n' +
          '        <td width="50%" valign="top" style="font-size: 10px;line-height: 14px;text-align: left; vertical-align: bottom">\n' +
          '            <strong style="font-size: 16px;">Client Request Form</strong><br /><br />\n' +
          '            <strong>Branch:</strong> '+branch+'<br />\n' +
          '            <strong>Survey Type:</strong> '+surveyType+'<br />\n' +
          '            <strong>Quote Number:</strong> '+payload.quoteNo+'<br />\n' +
          '            <strong>Customer Address:</strong> '+customerAddress+'<br />\n' +
          '        </td>\n' +
          '        <td width="50%" style="text-align: right;"><img src="https://www.builders.co.za/_ui/responsive/theme-yellow/images/Builders-responsive.jpg" width="28%" /></td>\n' +
          '    </tr>\n' +
          '    <table>\n' +
          '        <br />\n' +
          '        <table width="100%">\n' +
          '            <tr>\n' +
          '                <!-- JONIE UPDATED STYLE OF THIS TD -->\n' +
          '                <td colspan="3" style="font-weight: bold; border-bottom: 1px solid #f1f1f1; text-align: left;padding:10px 10px 0 5px;font-size: 12px;">CLIENT INFO</td>\n' +
          '            </tr>\n' +
          '            <tr>\n' +
          '                <!-- JONIE UPDATED STYLE OF THESE TD\'s -->\n' +
          '                <td width="33.33%" style="padding: 5px 5px 0;font-size: 8px;font-weight:bold; text-transform: uppercase">Name</td>\n' +
          '                <td width="33.33%" style="padding: 5px 5px 0;font-size: 8px;font-weight:bold; text-transform: uppercase">Contact Person Name</td>\n' +
          '                <td width="33.33%" style="padding: 5px 5px 0;font-size: 8px;font-weight:bold; text-transform: uppercase">Contact Person Cell</td>\n' +
          '            </tr>\n' +
          '            <tr>\n' +
          '                <!-- JONIE UPDATED STYLE OF THESE TD\'s -->\n' +
          '                <td width="33.33%" style="padding: 0 5px 5px;font-size: 8px; ">'+data.client_info_co_name+'</td>\n' +
          '                <td width="33.33%" style="padding: 0 5px 5px;font-size: 8px; ">'+data.client_info_contact+'</td>\n' +
          '                <td width="33.33%" style="padding: 0 5px 5px;font-size: 8px; ">'+data.client_info_cell+'</td>\n' +
          '            </tr>\n' +
          '            <tr>\n' +
          '                <!-- JONIE UPDATED STYLE OF THESE TD\'s -->\n' +
          '                <td width="33.33%" style="padding: 5px 5px 0;font-size: 8px;font-weight:bold; text-transform: uppercase">Acc No</td>\n' +
          '                <td width="33.33%" style="padding: 5px 5px 0;font-size: 8px;font-weight:bold; text-transform: uppercase">Message</td>\n' +
          '                <td width="33.33%" style="padding: 5px 5px 0;font-size: 8px;font-weight:bold; text-transform: uppercase">Email</td>\n' +
          '            </tr>\n' +
          '            <tr>\n' +
          '                <!-- JONIE UPDATED STYLE OF THESE TD\'s -->\n' +
          '                <td width="33.33%" style="padding: 0 5px 5px;font-size: 8px;">'+data.client_info_acc_no+'</td>\n' +
          '                <td width="33.33%" style="padding: 0 5px 5px;font-size: 8px;">'+data.client_message+'</td>\n' +
          '                <td width="33.33%" style="padding: 0 5px 5px;font-size: 8px;">'+data.client_info_email+'</td>\n' +
          '            </tr>\n' +
          '            <tr>\n' +
          '                <!-- JONIE UPDATED STYLE OF THESE TD\'s -->\n' +
          '                <td width="33.33%" style="padding: 5px 5px 0;font-size: 8px;font-weight:bold; text-transform: uppercase">Tel</td>\n' +
          '            </tr>\n' +
          '            <tr>\n' +
          '                <!-- JONIE UPDATED STYLE OF THESE TD\'s -->\n' +
          '                <td width="33.33%" style="padding: 0 5px 5px;font-size: 8px;">'+data.client_info_tel+'</td>\n' +
          '            </tr>\n' +
          '        </table>\n' +
          '        <br />\n' +

          htmlAdd +

          '</body>\n' +
          '</html>';

    var htmlDetails = {
      html: html
    }

    Vue.http.post(window.location.protocol + process.env.DEV_DOC + 'process', htmlDetails, rootState.headerDetails, { emulateJSON: false })
      .then(response => {
        return response.body;
      }, error => {
        console.log(error);
      }).then(data => {

      var reportDownload = document.createElement('a');
      reportDownload.setAttribute('href', 'data:application/octet-stream;base64,' + data);
      reportDownload.setAttribute('download', 'Quote-Details-for-QTE'+payload.quoteNo+'.pdf');
      reportDownload.click();

    });

    /*var modalDetails = { title: 'Edit Survey Doc', component: 'modal-survey-document', mstate: true, params: { surveyData: data } };
    commit({
      type: 'setModal',
      details: modalDetails
    });*/
    // commit( 'fncSetSurveyList', data );

  });
}

export const fncPopulateQuoteLinks = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  var linkDetails = { params: payload, manufacturer: objAuth.manufacturer };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getQuoteLinks', linkDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
      commit( 'fncSetQuoteLinks', data );
  });
}

export const fncCloneQuote = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);

  var objDetails = { a: 'cloneQuote', quoteId: payload.quote, branch_id: payload.branch_id, customer: payload.customer, department: payload.department, manufacturer: objAuth.manufacturer, status: payload.status, company: payload.company, project: payload.project }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php', objDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    if( data.success && data.success == true ) {
      var snackDetails = { color: 'success', message: 'The quote record has been cloned successfully', display: true };
      commit('setSnack', snackDetails);
      commit('fncSetQuoteNo', data.quoteNo);
      /*setTimeout(function() {
        location.reload();
      }, 1000)*/
    }
    else {
      var snackDetails = {color: 'error', message: 'Cloning the quote record failed', display: true};
    }
    commit('setSnack', snackDetails);
  });
}

export const fncExportRepToExcel = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  var downloadDetails = { manufacturer: objAuth.manufacturer };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=fncExportRepToExcel', downloadDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

    var reportDownload = document.createElement('a');
    reportDownload.setAttribute('href', data.file);
    reportDownload.setAttribute('download', 'rep-export.xlsx');
    reportDownload.click();

  });
}

export const fncViewCompanyUsers = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);

  var objDetails = { a: 'get_company_users', 'company_id': payload, manufacturer: objAuth.manufacturer }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Company.php', objDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
   
		console.log('Data');
		console.log( data );

  });
}

export const fncUploadAvatar = ({ commit, dispatch, state, rootState }, payload) => {
	var uploadData = new FormData();
	var objAuth = JSON.parse(rootState.objAuthorize);
	var randInt = Math.floor((Math.random() * 9999) + 1000);
	uploadData.append('fileInput', payload.files, payload.files.name);
  	uploadData.append('manufacturerID', objAuth.manufacturer);

	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'QuoteAttachment.php', uploadData, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error occured while trying to upload the quote file', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {

			var imgUrl = window.location.protocol + process.env.DEV_ENDPOINT + 'attachments/' + data.file_name;
			commit('fncSetUserAvatar', imgUrl);

	});

};

export const fncUserListShort = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);

  var objDetails = { a: 'user_list_short', 'type': 1, manufacturer: objAuth.manufacturer }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php', objDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

		commit('fncSetRepsShortList', data);
   
  });
}

